module.exports = __webpack_public_path__ + "img/Price-List-m.e9928613.png";